export default {
	'general/argument_error': 'Argument(s) contains error',
	'general/unknown_error': 'Unknown error, message: {0}',
	'general/missing_argument':	'Missing argument {0}',
}